export const appConfig = {
  // api version & endpoint roots
  apiVersion: "v1",
  identityApiBaseUrl: process.env.REACT_APP_IDENTITY_API_BASE_URL!,
  merchantApiBaseUrl: process.env.REACT_APP_MERCHANT_API_BASE_URL!,

  // data storage
  APP_DATA_STORAGE_KEY: "SWITCHAPP_DATA_STORE_KEY",

  // formatting
  javascriptCodeDateFormat: "MM/DD/YYYY",
  dateFormat1: "MMM DD, YYYY",
  dateFormat2: "M d, Y",
  dateFormat3: "MM YYYY",
  dateFormat4: "YYYY.MM.DD",
  dateFormat5: "DD MMM, YYYY",
  dotNetDateFormat: "yyyy-MM-DD",
  timeFormat1: "hh:mm A",
  timeFormat2: "hh:mm:ss A",
  timeFormat3: "HH:mm A",
  dateTimeFormat: "ddd MMM DD, YYYY, hh:mm A",

  // query caching
  queryCacheIntervalInMins: 20,
  balancesQueryCacheIntervalInMins: 5,
  queryRetryEnabled: false,

  // merchant redirect
  merchantRedirectDelayMs: 5000, // 5 seconds
};
